import { Link } from 'react-router';
import { t } from '@/i18n';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <main id="main" tabIndex={-1} className="canvas-dots grid min-h-full place-items-center p-6">
      <div className="glass max-w-sm p-8 text-center animate-pop-in">
        <svg viewBox="0 0 120 80" className="mx-auto mb-5 h-20 w-32" aria-hidden>
          <rect x="10" y="14" width="44" height="44" rx="6" fill="#FFF1A8" transform="rotate(-6 32 36)" />
          <rect x="62" y="20" width="44" height="44" rx="6" fill="#E5D4FF" transform="rotate(5 84 42)" />
          <text x="32" y="44" textAnchor="middle" fontSize="20" fontWeight="700" fill="#1C1917" transform="rotate(-6 32 36)">4</text>
          <text x="84" y="50" textAnchor="middle" fontSize="20" fontWeight="700" fill="#1C1917" transform="rotate(5 84 42)">04</text>
        </svg>
        <h1 className="text-lg font-semibold">{t('errors.notFound')}</h1>
        <p className="mt-1.5 text-sm text-fg-muted">{t('errors.notFoundHint')}</p>
        <Link to="/" className="mt-6 inline-block">
          <Button variant="primary">{t('errors.toHome')}</Button>
        </Link>
      </div>
    </main>
  );
}
